import React from 'react'
import css from "./footer.module.css"
import Logo from "../../assets/logo.png"
import {InboxIcon,PhoneIcon,LocationMarkerIcon,LoginIcon,UsersIcon,LinkIcon} from "@heroicons/react/outline"
const Footer = () => {
  return (
<div className={css.cFooterWrapper}>
    <hr/>
    <div className={css.cFooter}>
        <div className={css.clogo}>
            <img src={Logo} alt="" />
            <span>AmazShop</span>
        </div>
        <div className={css.bloc}>
            <div className={css.details}>
                <span className={css.detailsTitle}>Contact US</span>
                <div className={css.detail}>
                <span className={css.pngline}>
                <LocationMarkerIcon className={css.icon}/>
                </span>
                <span>11 North Avenue Orlando, N578</span>
            </div>

            <div className={css.detail}>
                <span className={css.pngline}>
                <PhoneIcon className={css.icon}/>
                </span>
                <span>+212-06XXXXXXXX</span>
            </div>

            <div className={css.detail}>
                <span className={css.pngline}>
                <InboxIcon className={css.icon}/>
                </span>
                <span>amazshop@gmail.com</span>
            </div>
            
            </div>
        </div>

        <div className={css.bloc}>
            <div className={css.details}>
                <span className={css.detailsTitle}>Account</span>
                <div className={css.detail}>
                <span className={css.pngline}>
                <LoginIcon className={css.icon}/>
                </span>
                <span>sign In</span>
            </div>

            
            
            </div>
        </div>

    </div>
    <div className={css.copyright}>
        <span>All right reserved 2023</span>
        <span>Yassnozer</span>
    </div>
</div>
    )
}

export default Footer